"use client"

import { HugeiconsIcon } from "@hugeicons/react"
import { Button } from "../../ui/button"
import { ArrowLeft01Icon } from "@hugeicons/core-free-icons"
import { WeatherDay } from "./WeatherCarousel"
import { Dispatch, SetStateAction } from "react"
import { WeatherCard } from "./WeatherCard"
import WeatherSlide from "./WeatherSlide"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  useCarousel,
} from "@/components/ui/carousel"

// Navigation component that uses carousel context
function WeatherNavigation() {
  const { scrollPrev, scrollNext, canScrollPrev, canScrollNext } = useCarousel()

  return (
    <>
      <Button
        className="hidden md:flex size-6 rounded-full p-0 md:p-0 -scale-x-100"
        onClick={scrollPrev}
        disabled={!canScrollPrev}
      >
        <HugeiconsIcon className="size-3" icon={ArrowLeft01Icon} />
      </Button>
      <Button
        className="hidden md:flex size-6 rounded-full p-0 md:p-0"
        onClick={scrollNext}
        disabled={!canScrollNext}
      >
        <HugeiconsIcon className="size-3" icon={ArrowLeft01Icon} />
      </Button>
    </>
  )
}

const WeatherSlider = ({
  days,
  collapsed,
  setCollapsed,
  setIsHovered,
  timerRefCurrent,
}: {
  days: WeatherDay[]
  setCollapsed: Dispatch<SetStateAction<boolean>>
  collapsed: boolean
  setIsHovered: Dispatch<SetStateAction<boolean>>
  timerRefCurrent: NodeJS.Timeout | null
}) => {
  return (
    <div
      className="relative flex items-center"
      onMouseEnter={() => {
        setIsHovered(true)
        setCollapsed(false)
      }}
      onMouseLeave={() => {
        setIsHovered(false)
        if (days.length > 1) {
          timerRefCurrent = setTimeout(() => setCollapsed(true), 4000)
        }
      }}
    >
      <WeatherCard day={days[0]} />

      <div
        className={`transition-all duration-500 overflow-hidden ${
          collapsed ? "max-w-0" : "max-w-96"
        }`}
      >
        <Carousel
          opts={{
            align: "start",
            loop: false,
            dragFree: true,
          }}
          dir="rtl"
          className="shrink-0 w-80 md:w-80"
        >
          <div className="flex items-center gap-1 px-2 border-r border-black-50 mr-4">
            <WeatherNavigation />
            <CarouselContent className="-mr-2">
              {days.map((d) => (
                <CarouselItem key={d.date} className="basis-auto pr-2">
                  <WeatherSlide day={d} />
                </CarouselItem>
              ))}
            </CarouselContent>
          </div>
        </Carousel>
      </div>
    </div>
  )
}

export default WeatherSlider
